import AccountController from './accountController';
import ErrorController from './errorController';
import AddressModel from '../models/addressModel';
import ProfileModel from '../models/profileModel';
import AddressViewModel from '../viewModels/addressViewModel';
import AddressTemplate from '../../templates/address.j2';
import * as AuthController from './authController';
import AddressConfigModel from '../models/addressConfigModel';
import HeaderController from './headerController';
import {
    getSiteBySiteId,
    getInitialSelectedCountry,
    getInitialGroupType
} from '../helpers/helpers';

/**
 * Controller used for /address
 */
class AddressController extends AccountController {
    // removed template from constructor
    constructor(model, viewModel, AddressConfigModel) {
        super();

        this.AddressModel = model;
        this.AddressViewModel = viewModel;
        // this.AddressTemplate = template;
        this.self = this;
    }
    /**
     * Contains promise chain used to render contents on the address & payments page
     * Called From:
     * router.route('address').enter() or router.go('address', false).done()
     */
    render(store) {
        AddressModel.createLoader();

        // get session
        AuthController.authenticate()
            // set session if retrieved from API
            .then(session => {
                return AuthController.saveSession(session);
            })
            // render header
            .then(session => {
                return HeaderController.render(store);
            })
            // get user addresses from /me/addresses
            .then(session => {
                return super.get(AddressModel, 'getAddresses', AuthController.get('session'), 'userAddresses');
            })
            // save address info to model
            .then(addressData => {
                return super.set(AddressModel, addressData, 'userAddresses', true);
            })
            // get user payments from /me/payments
            .then(session => {
                return super.get(AddressModel, 'getPayments', AuthController.get('session'), 'userPayments');
            })
            // save payments info to model
            .then(paymentData => {
                return super.set(AddressModel, paymentData, 'userPayments', true);
            })
            // directly call the model method to filter and save orphan payments to the model
            .then(paymentModel => {
                return AddressModel.createOrphans();
            })
            // get user profile from /me
            .then(session => {
                return super.get(ProfileModel, 'getProfile', AuthController.get('session'), 'profile');
            })
            // save profile info to model
            .then(profileData => {
                return super.set(ProfileModel, profileData, 'profile');
            })
            // save country info to the AddressConfigModel
            .then(data => {
                const countriesResponse = {
                    data: store.core.siteConfig.allCountries,
                    nonApiResponse: true
                };
                return super.set(AddressConfigModel, countriesResponse, 'countries');
            })
            //   save groupType info to the AddressConfigModel
            .then(data => {
                const groupTypeResponse = getInitialGroupType(store); // store is actually state?
                return super.set(AddressConfigModel, groupTypeResponse, 'groupType');
            })
            .then(data => {
                return super.set(AddressConfigModel, getInitialSelectedCountry(store), 'selectedCountry');
            })
            // get user registry status from /search/{user_id}
            .then(session => {
                return super.get(ProfileModel, 'getRegistryInfo', AuthController.get('session'), 'registryInfo');
            })
            // save user registry info to model
            .then(registryData => {
                return super.set(ProfileModel, registryData, 'registryInfo', true);
            })
            // generate template
            .then(address => {
                return super.generateTemplate(AddressConfigModel, AddressTemplate, AddressModel, AddressViewModel, 'Address', store);
            })
            // attach template to DOM
            .then(template => {
                return super.attachTemplateToDom(template);
            })
            // attach events to DOM
            .then(DOM => {
                return super.attachEvents(AddressViewModel, this, AddressModel, AuthController.get('session'), store);
            })
            // turn off view model temp states
            .then(DOM => {
                if (store.core.googleMapsReady) {
                    AddressViewModel.autoComplete(this, AddressModel, store);
                } else {
                    document.addEventListener('a15-google-maps-ready', () => {
                        AddressViewModel.autoComplete(this, AddressModel, store);
                    });
                }

                return AddressViewModel.disableTempStates();
            })
            // turn off model temp states
            .then(DOM => {
                AddressModel.destroyLoader();
                console.log(AddressModel);
                console.log(AddressViewModel);
                console.log(store);
                return AddressModel.disableTempStates();
            })
            // catch any errors
            .catch(error => {
                AddressModel.destroyLoader();
                console.log('AddressController catch error');
                console.log(error);
                if (error.type === 'serviceError') {
                    ErrorController.handleErrors(error, AddressModel, AddressViewModel, this);
                }
            });
    }
}

// Create an object from the AddressController class
const address = new AddressController(AddressModel, AddressViewModel, AddressConfigModel);
// Export object created from AddressController class
export default address;
